import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/tipoRegistro';
import Tipo from './TipoRegistroList';


const ms2p = (state) => {
  return {
    ...state.rs_tipo_registro,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipo);
